module.exports = __webpack_public_path__ + "img/pmf_03.6431423e.png";